const isBrowser = typeof window !== 'undefined'

function getDashboardURL(url) {
  if (isBrowser) {
    const urlParams = new URLSearchParams(window.location.search)
    let first = true

    for (const [key, value] of urlParams.entries()) {
      if (first) {
        url += `?${key}=${value}`
        first = false
      } else {
        url += `&${key}=${value}`
      }
    }
  }

  return url
}

export function getDashboardCreateUserURL() {
  const url = getDashboardURL('https://dashboard.arena.im/auth/create')

  return url
}

export function getDashboardLoginUserURL() {
  const url = getDashboardURL('https://dashboard.arena.im/auth/login')

  return url
}
